import type { Variant } from '../services/schemas';

export function groupVariantsByProductType(variants: Variant[]): Map<string, Variant[]> {
  return variants.reduce<Map<string, Variant[]>>((map, v) => {
    const key = v.productType.name;
    if (!map.has(key)) map.set(key, []);
    map.get(key)!.push(v);
    return map;
  }, new Map());
}
